export default "__VITE_ASSET__70d2293a__"